import React from 'react';
import { ButtonSize } from '../Button';
import SpirisIcon from '../Icon/SpirisIcon';

interface SkynetIconButtonProps {
    icon: string;
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    active?: boolean; // Omit for a plain action button; a boolean makes it a controlled toggle (glyph, `pressed`, aria-pressed).
    expanded?: boolean;
    iconActive?: string;
    filled?: boolean;
    solid?: boolean;
    size?: string;
    title?: string;
    className?: string;
}

export const SkynetIconButton = ({
    icon,
    label,
    onClick,
    disabled = false,
    active,
    expanded,
    iconActive,
    filled = false,
    solid = false,
    size = ButtonSize.DEFAULT,
    title,
    className = '',
}: SkynetIconButtonProps): React.JSX.Element => {
    const iconName = (active === true || expanded === true) && iconActive !== undefined ? iconActive : icon;
    const classes = `btn btn-icon${size}${solid ? ' btn-solid' : ''}${disabled ? ' disabled' : ''}${active === true ? ' pressed' : ''}${className !== '' ? ` ${className}` : ''}`;

    return (
        <button type="button" className={classes} onClick={onClick} disabled={disabled} aria-pressed={active} aria-expanded={expanded} title={title ?? label}>
            <SpirisIcon name={iconName} filled={filled} size={size === ButtonSize.SMALL ? 'sm' : ''} />
            <span className="sr-only">{label}</span>
        </button>
    );
};

export default SkynetIconButton;
